import { Box, Stack, Typography } from "@mui/material"

export const SplashScreen = () => {
    return <>
    <Stack sx={{
        alignItems: "center",
        justifyContent: "center"
        
    }}>
        <Box sx={{
            paddingTop: "100px",
            paddingBottom: "48px",
            paddingLeft: "120px"
        }}>
            <img height="100%" alt="splash robot" src="./assets/robots/splashscreen.png" />
        </Box>
        <Typography sx={{
            fontWeight: "bold",
            fontSize: "28px"
        }}>Say Hi to Flashbot!</Typography>
        <Typography>To begin, login to the system</Typography>
    </Stack>
    </>
}